import React from "react";
import { useMediaQuery } from 'react-responsive';

import VtrgVideo from "../vtrg_video/vtrg_video.jsx";
import VtrgCustomHtml from "../vtrg_custom_html/vtrg_custom_html.jsx";
import { request } from "../../../api.js";

const VtrgVideoOther = ({ info }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return (
    <>
      {info.blocks && info.blocks.length > 0 ? (
        <div className="vtrg-video-and-something">
          {info.blocks.map((item, index) => {
            if (typeof item.other === 'string') {
              item.other = JSON.parse(item.other)
            }
            if (typeof item.video === 'string') {
              item.video = JSON.parse(item.video)
            }
            if (typeof item.image === 'string') {
              item.image = JSON.parse(item.image)
            }

            const curBlockStyle = {
              padding: item.other.block_padding && !isMobile ? item.other.block_padding : "",
              backgroundColor: item.other.bg_color && !isMobile ? item.other.bg_color : "",
            };

            const resultVideo =
              ((item.other.block_type === 1) || !item.other.block_type) ? (
                item.video && <VtrgVideo video={item.video} />
              ) : (
                ""
              );
            const curImg =
              item.image && item.image.image && item.image.image.url
                ? `${request}${item.image.image.url}`
                : "";
            const resultImg =
              item.other.block_type === 2 ? (
                <img className="vtrg-video-and-something__img" src={curImg} />
              ) : (
                ""
              );
            const resultHtml =
              item.other.block_type === 3 ? (
                <VtrgCustomHtml data={item.html} />
              ) : (
                ""
              );

            return (
              <div
                className="vtrg-video-and-something_container"
                style={curBlockStyle}
                key={index}
              >
                {resultImg && resultImg}
                {resultVideo && resultVideo}
                {resultHtml && resultHtml}
              </div>
            );
          })}
        </div>
      ) : (
        <div/>
      )}
    </>
  );
};

export default VtrgVideoOther;
